if (!customElements.get('quick-add-modal')) {  
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
      
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }
  
      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
  
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
  
      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden'); 
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {           
             
            if(document.querySelector('quick-add-modal[open=""]')){
              var popupdiv = document.querySelector('quick-add-modal[open=""] .quick-add-modal__toggle');
              popupdiv.click();
            }
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            var currentprodid = this.productElement.querySelector("#format-containers-buttons").getAttribute('data-prodid');
             setTimeout(() => {      
                document.getElementById('loading-overlay')?.classList.add('hidden');
              }, 2000);
            // Make sure that productElement exists
            if (this.productElement) {
              
              this.newdevlink = this.productElement.querySelectorAll("#format-containers-buttons .format-button");    
              for (let i = 0; i < this.newdevlink.length; i++) {
               
                var devname = this.newdevlink[i].getAttribute('title');
                var devlink = this.newdevlink[i].getAttribute('href');
                var devsku = this.newdevlink[i].getAttribute('data-sku');
                var devpubdate = this.newdevlink[i].getAttribute('data-pub-date');
                var devprodid = this.newdevlink[i].getAttribute('data-prodid'); 
                var requiresshipping = this.newdevlink[i].getAttribute('data-requires_shipping');
                this.newdevlink[i].innerHTML += '<modal-opener data-modal="#QuickAdd-'+devprodid+'"><button data-product-url="'+devlink+'" aria-label="'+devname+'" data-sku="'+devsku+'" data-pub-date="'+devpubdate+'" data-requires-shipping="'+requiresshipping+'" onclick="handlePdpChange({dataSku: '+devsku+', dataRequiresShipping: '+requiresshipping+' }); return false;"><span></span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></modal-opener>';
                this.newdevlink[i].removeAttribute('href');
              }  
              
            } else {
              console.error('Product element not found');
            }
            
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
  
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
  
            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
            var descmore = document.querySelector('a.product__description-more');
            if(descmore){
              var produrl = opener.getAttribute('data-product-url');
              descmore.setAttribute('href', produrl);
            }
            var dataSku = opener.getAttribute('data-sku');
            var requiresshipping = opener.getAttribute('data-requires-shipping');
            const apiUrl = 'https://indiepubsus.ingramcontent.com/api/v1/marketplace.existingProductStock';   
             var pubdate = opener.getAttribute('data-pub-date');
                 if (requiresshipping == 'true' ) {
                    fetch(apiUrl + '?isbn=' + dataSku +'&publicationDate=' + pubdate, {
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                    })
                      .then((response) => {
                        if (!response.ok) {
                          throw new Error('Network response was not ok');
                        }
                        return response.json();
                      })
                      .then((data) => {
                        // For loader 

                        const elementbtn = document.querySelector('.product-forms-buttons');
                        document.getElementById('loading-overlay-button').classList.add('hidden');
                        if (elementbtn && elementbtn.classList.contains('hidden')) {
                            elementbtn.classList.remove('hidden');
                        }
                        document.getElementById('loading-overlay').classList.add('hidden');
                        var productBuyButtons = document.getElementsByClassName('productBuyButtons');

                        for (var i = 0; i < productBuyButtons.length; i++) {
                            if (productBuyButtons[i].classList.contains('hidden')) {
                                productBuyButtons[i].classList.remove('hidden');
                                productBuyButtons[i].style.display="block";
                            }
                        }

                        // End
                        var productBuyButtons = document.getElementsByClassName('productBuyButtons');
                        var notifyMeButtonContainer = document.querySelector('.notify-me-button-container');
                        var preOrderButtonContainer = document.querySelector('.pre-order-button-container');
                        
                        // setTimeout(() => {
                        const loader = document.getElementById('loadingimg');
                        if (loader) {
                          loader.style.display = 'none';
                        }
                        // For server timeout issue 
                        const isErrorObject = !Array.isArray(data) && (data.status || data.type);
                        const isEmptyArray = Array.isArray(data) && (!data[0] || data[0].status || data[0].type);

                        if (isErrorObject || isEmptyArray) {
                            notifyMeButtonContainer.style.display = 'block';
                            for (var i = 0; i < productBuyButtons.length; i++) {
                              productBuyButtons[i].style.setProperty('display', 'none', 'important');
                            }
                            return false;
                        }
                        
                        var preorderDays = "180";
                        const today = new Date();
                        const yyyy = today.getFullYear();
                        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                        const dd = String(today.getDate()).padStart(2, '0');
                        const todayFormatted = `${yyyy}-${mm}-${dd}`;
                        
                        // Assume data is already defined and has a publicationDate string in YYYY-MM-DD format
                        var publicationDate = data[0].publicationDate;

                        // Parse dates
                        const pubDateObj = new Date(publicationDate);
                        const todayObj = new Date(todayFormatted);

                        // Check for invalid date
                        if (isNaN(pubDateObj.getTime())) {
                          console.error("Invalid publication date format:", publicationDate);
                        }

                        const diffInMs = pubDateObj.getTime() - todayObj.getTime();
                        const daysUntilPublicationRaw = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
                        const daysUntilPublication = Math.max(0, daysUntilPublicationRaw); // Prevent negative days

                        if (data[0].inStock) {
                          //notifyMeButtonContainer.style.display = 'none';
                          const loader = document.getElementById('loadingimg');
                          if (loader) {
                            loader.style.display = 'none';
                          }

                               notifyMeButtonContainer.style.display = 'none';
                              if ( daysUntilPublicationRaw > preorderDays){
                                notifyMeButtonContainer.style.display = 'block';
                                for (var i = 0; i < productBuyButtons.length; i++) {
                                productBuyButtons[i].style.setProperty('display', 'none', 'important');
                              }
                              } else if(preOrderButtonContainer) {
                                 preOrderButtonContainer.style.display = 'block';
                              }
                              else {
                                for (var i = 0; i < productBuyButtons.length; i++) {
                                productBuyButtons[i].style.setProperty('display', 'block', 'important');
                              }
                              }
                        } else {
                          // Product is out of stock or data is unavailable
                          // Display pre-order button container if applicable
                          if (preOrderButtonContainer) {
                            preOrderButtonContainer.style.display = 'block';
                            notifyMeButtonContainer.style.display = 'none';
                          }
                          // Display notify me button container
                          if (!preOrderButtonContainer && notifyMeButtonContainer) {
                            notifyMeButtonContainer.style.display = 'block';
                          }
                          // Hide product buy buttons
                          for (var i = 0; i < productBuyButtons.length; i++) {
                            productBuyButtons[i].style.display = 'none';
                          }
                        }
                      })
                      .catch((error) => {
                        var productBuyButtons = document.getElementsByClassName('productBuyButtons');
                        var notifyMeButtonContainer = document.querySelector('.notify-me-button-container');
                        var preOrderButtonContainer = document.querySelector('.pre-order-button-container');
                        console.error('Error fetching stock information:', error);
                        // setTimeout(() => {
                        const loader = document.getElementById('loadingimg');
                        loader.style.display = 'none';
                        const errorMessage = document.getElementById('errorMessage');
                        errorMessage.classList.remove('display-none');
                        errorMessage.classList.add('error-container');
                        // }, 5500);
                        if (notifyMeButtonContainer) {
                            notifyMeButtonContainer.style.display = 'none';
                          }
  
                          // Hide pre-order button container if applicable
                          if (preOrderButtonContainer) {
                            preOrderButtonContainer.style.display = 'none';
                          }
  
                          // Hide product buy buttons
                          for (var i = 0; i < productBuyButtons.length; i++) {
                            productBuyButtons[i].style.display = 'none';
                          }
                      });
                 }else if (requiresshipping == 'false' ) {
                   const apiVitalUrl = 'https://indiepubsus.ingramcontent.com/api/v1/marketplace.verifyDigitalStock';
                    
                      fetch(apiVitalUrl, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                          isbn: dataSku
                        })
                      })
                      .then((response) => {
                        if (!response.ok) {
                          throw new Error('Network response was not ok');
                        }
                        return response.json();
                      })
                      .then((data) => {
                        // For loader 

                        const elementbtn = document.querySelector('.product-forms-buttons');
                        document.getElementById('loading-overlay-button').classList.add('hidden');
                        if (elementbtn && elementbtn.classList.contains('hidden')) {
                            elementbtn.classList.remove('hidden');
                        }
                        document.getElementById('loading-overlay').classList.add('hidden');
                        var productBuyButtons = document.getElementsByClassName('productBuyButtons');

                        for (var i = 0; i < productBuyButtons.length; i++) {
                            if (productBuyButtons[i].classList.contains('hidden')) {
                                productBuyButtons[i].classList.remove('hidden');
                                productBuyButtons[i].style.display="block";
                            }
                        }

                        // End
                        var productBuyButtons = document.getElementsByClassName('productBuyButtons');
                        var notifyMeButtonContainer = document.querySelector('.notify-me-button-container');
                        const loader = document.getElementById('loadingimg');
                        if (loader) {
                          loader.style.display = 'none';
                        }
                        let item; 
                        if (data.isbn == dataSku){
                               item = dataSku;
                            }
                            if (data && data?.distributable === true) {
                         // vsContainer.innerHTML = `<button type="submit" name="add" class="btn">Add to Basket</button>`;
                           for (var i = 0; i < productBuyButtons.length; i++) {
                            productBuyButtons[i].style.display = 'block';
                          }
                        } else {
                          if (notifyMeButtonContainer) {
                            notifyMeButtonContainer.style.display = 'block';
                          }
                          for (var i = 0; i < productBuyButtons.length; i++) {
                            productBuyButtons[i].style.display = 'none';
                          }
                        }
                      })
                      .catch(error => {
                        const loader = document.getElementById('loadingimg');
                        if (loader) {
                          loader.style.display = 'none';
                        }
                        const errorMessage = document.getElementById('errorMessage');
                        errorMessage.classList.remove('display-none');
                        errorMessage.classList.add('error-container');
                        console.error('Error fetching Vital Source information main product:', error);
                        var productBuyButtons = document.getElementsByClassName('productBuyButtons');
                        var notifyMeButtonContainer = document.querySelector('.notify-me-button-container');
                        if (notifyMeButtonContainer) {
                          notifyMeButtonContainer.style.display = 'none';
                        }
                        for (var i = 0; i < productBuyButtons?.length; i++) {
                          productBuyButtons[i].style.display = 'none';
                        }
                      });
                   }else{
                    const loader = document.getElementById('loadingimg');
                        if (loader) {
                          loader.style.display = 'none';
                        }
                      var productBuyButtons = document.getElementsByClassName('productBuyButtons');
                        if (productBuyButtons) {
                           for (var i = 0; i < productBuyButtons.length; i++) {
                             productBuyButtons[i].style.display = 'block';
                           }
                        }
                 }
          });
      }
  
      setInnerHTML(element, html) {
        element.innerHTML = html;
  
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach(oldScriptTag => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value)
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
  
      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;
  
        variantPicker.setAttribute('data-update-url', 'false');
      }
  
      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
  
        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
  
        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach(modal => modal.remove());
      }
  
      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }
  
      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
  
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }
  
      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;
  
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;
  
        let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 768px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        
        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }
  
        mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
      }
    });
  }

